// extracted by mini-css-extract-plugin
module.exports = {"submitted":"SubmittedStatus_submitted__3fNNK"};